import { Link } from 'react-router-dom';
import type { Movie } from '@/types/media';
import { formatDate, typeLabel } from '@/utils/media';

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 hover:bg-background-100/60 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title}海报`}
          title={`${movie.title} - 91爱爱影视`}
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur">
          {typeLabel(movie.type)}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-semibold text-background-50">
          <i className="ri-star-fill text-[10px]" />
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 translate-y-full bg-gradient-to-t from-foreground-950/90 to-transparent px-3 pb-3 pt-6 transition-transform duration-300 group-hover:translate-y-0">
          <p className="line-clamp-2 text-xs leading-relaxed text-background-100">{movie.summary}</p>
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-2 p-3">
        <h3 className="line-clamp-1 font-heading text-sm font-semibold text-foreground-950">
          {movie.title}
        </h3>
        <p className="line-clamp-1 text-xs text-foreground-500">{movie.subtitle}</p>
        <div className="mt-auto flex flex-wrap items-center gap-1.5">
          {movie.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-800"
            >
              {genre}
            </span>
          ))}
          <span className="text-[11px] text-foreground-400">{movie.region}</span>
        </div>
        <div className="flex items-center justify-between border-t border-background-200 pt-2 text-[11px] text-foreground-400">
          <span>{movie.year}</span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {formatDate(movie.updatedAt)}更新
          </span>
        </div>
      </div>
    </Link>
  );
}